import { InjectionToken } from '@angular/core';

export type GpkgAutoStyleType = 'standort' | 'humusform' | 'haken' | string | null;

export interface GpkgAutoStyleHandler {
	detectAutoStyle(attributeNames: string[]): GpkgAutoStyleType;
}

export const GPKG_AUTO_STYLE_HANDLER = new InjectionToken<GpkgAutoStyleHandler>(
	'GPKG_AUTO_STYLE_HANDLER'
);
